import { Link } from "expo-router";
import { Text, TouchableOpacity, View } from "react-native";
import { ColumnModel } from "app/services/api/types/common/models/ColumnModel";
import { useMemo } from "react";
import {
  getColumnWidths,
  calculateTotalFr,
  getColumnStyle,
} from "../utils/columnWidthUtils";

interface Props<T> {
  item: T;
  className?: string;
  columns: ColumnModel<T>[];
  clickablePath?: (item: T) => string;
  onRowPress?: (item: T) => void;
  showHorizontalRowDivider?: boolean;
}

export function TableRow<T>({
  item,
  columns,
  className,
  clickablePath,
  onRowPress,
  showHorizontalRowDivider,
}: Props<T>) {
  const path = clickablePath ? clickablePath(item) : null;

  const columnWidths = useMemo(() => getColumnWidths(columns), [columns]);
  const totalFr = useMemo(() => calculateTotalFr(columnWidths), [columnWidths]);

  const content = (
    <View
      className={`
     pb-10 last:pb-0 md:px-10 px-6 w-full
    ${showHorizontalRowDivider ? "border-b border-gray-200 last:border-b-0 pb-5 pt-5" : ""}
    ${className}
  `}
      style={{
        flexDirection: "row",
        gap: 32,
        alignItems: "center",
        minWidth: "100%",
      }}
    >
      {columns.map((column, colIndex) => {
        const width = columnWidths[colIndex] || "1fr";
        const style = getColumnStyle(width, totalFr, columns.length, column.minWidth);

        return (
          <View key={colIndex} style={style}>
            {column.renderCell ? (
              column.renderCell(item)
            ) : column.dataKey ? (
              <Text>
                {String(
                  column.transform
                    ? column.transform(item[column.dataKey], item)
                    : item[column.dataKey],
                )}
              </Text>
            ) : null}
          </View>
        );
      })}
    </View>
  );

  if (path) {
    return (
      <Link href={path} className="pb-10 last:pb-0">
        {content}
      </Link>
    );
  }

  if (onRowPress) {
    return (
      <TouchableOpacity
        onPress={() => onRowPress(item)}
        activeOpacity={0.7}
        className="pb-10 last:pb-0"
      >
        {content}
      </TouchableOpacity>
    );
  }

  return content;
}
